import React from "react";

export const rayosYCentellasPublishedAt = (
  <span className="white">
    <i>El país de Lilac</i> (1938)
  </span>
);
